import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genStepsLabelPlacementStyle = function genStepsLabelPlacementStyle(token) {
  var componentCls = token.componentCls,
    iconSize = token.iconSize,
    lineHeight = token.lineHeight,
    iconSizeSM = token.iconSizeSM;
  return _defineProperty({}, "&".concat(componentCls, "-label-vertical"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-item"), {
    overflow: 'visible',
    '&-tail': {
      marginInlineStart: token.calc(iconSize).div(2).add(token.controlHeightLG).equal(),
      padding: "0 ".concat(unit(token.paddingLG))
    },
    '&-content': {
      display: 'block',
      width: token.calc(iconSize).div(2).add(token.controlHeightLG).mul(2).equal(),
      marginTop: token.marginSM,
      textAlign: 'center'
    },
    '&-icon': {
      display: 'inline-block',
      marginInlineStart: token.controlHeightLG
    },
    '&-title': {
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      '&::after': {
        display: 'none'
      }
    },
    '&-subtitle': {
      display: 'block',
      marginBottom: token.marginXXS,
      marginInlineStart: 0,
      lineHeight: lineHeight
    }
  }), "&".concat(componentCls, "-small:not(").concat(componentCls, "-dot)"), _defineProperty({}, "".concat(componentCls, "-item"), {
    '&-icon': {
      marginInlineStart: token.calc(iconSize).sub(iconSizeSM).div(2).add(token.controlHeightLG).equal()
    }
  })));
};
export default genStepsLabelPlacementStyle;